import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpand45: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="expand-45, enlarge"><path d="M13.75 3.75H20.25V10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 13.75V20.25H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.4766 4.52344L13.75 10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.25 13.75L4.52344 19.4766" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconExpand45;
